import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setDefaultFilter } from 'store/actions/jobsQueue_actions';
import { submitOrder } from 'store/actions/quarry_actions';

import Modal from 'components/Modal';
import FlashMessage from 'components/FlashMessage';
import crypto from 'crypto';
import { getPublicKey } from '../../../utils/api.service';
import Tooltip from '../../../components/Tooltip';

class ProductsModal extends React.Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object),
    testCase: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    loggedInUserEmail: PropTypes.string,
    selectedProduct: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
  };

  static defaultProps = {
    fields: [],
    options: [],
  };

  state = {
    selectedOption: {},
    fieldValues: {
      quantity: '',
    },
    errors: {},
    isSubmitting: false,
  };

  constructor() {
    super();

    this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
    this.handleSubmitFormClicked = this.handleSubmitFormClicked.bind(this);
  }

  componentDidMount() {
    const fieldValues = {};

    // set default values
    this.props.fields.forEach((field) => {
      fieldValues[field.field] = field.default;
    });

    this.setState({ fieldValues });
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.isSending &&
      prevProps.isSending &&
      this.props.status >= 200 &&
      this.props.status < 300
    ) {
      this.setState({ isSubmitting: false });
      this.props.onClose();
    }

    // Reset loading state if submission fails
    if (
      !this.props.isSending &&
      prevProps.isSending &&
      this.props.status >= 400
    ) {
      this.setState({ isSubmitting: false });
    }
  }

  handleFormFieldChange(field) {
    return (value) => {
      this.setState((state) => {
        return { fieldValues: { ...state.fieldValues, ...{ [field]: value } } };
      });
    };
  }

  async handleSubmitFormClicked() {
    // Set loading state immediately when user clicks submit
    this.setState({ isSubmitting: true });

    try {
      let password = '';
      if (this.state.fieldValues.password) {
        let publicKey = await getPublicKey();
        console.log(this.state.fieldValues.password);
        const encryptedPassword = crypto
          .publicEncrypt(
            {
              key: publicKey,
              padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
            },
            Buffer.from(this.state.fieldValues.password)
          )
          .toString('base64');
        password = encryptedPassword;
      }

      let orderId = 'a1b9560d-19c0-4271-9551-67ea420481f1';
      let executionname = 'Direct Estore Order';
      let emailKeyName = 'contact';
      if (this.props.testCase.intendedUsage === 'NFR') {
        orderId = 'a5fadfcd-cc1b-44e5-b6ea-27871aed84cb';
        executionname = 'NFR Quote to Order';
        //emailKeyName = 'agentEmail';
      } else if (this.props.testCase.intendedUsage === 'ACS') {
        orderId = 'f81891b3-ede4-429a-9063-008beb115e3f';
        executionname = 'ACS Quote to Order';
      }

      const payload = {
        environment: 'stg',
        notificationemail: this.props.loggedInUserEmail,
        executionname: executionname,
        project: 'agency',
        org: 'newbuyingexperience',
        isNXM: true,
        workstream: 'newbuyingexperience',
        testcases: [
          {
            orderid: orderId,
            name: executionname,
            testdata: {
              store: this.state.fieldValues.store,
              payment: 'CC',
              [emailKeyName]: this.state.fieldValues.emailId,
              password: password,
              lineitems: [],
              offering: [
                {
                  offeringId: this.props.testCase.offeringId,
                  quantity: this.state.fieldValues.quantity || 1,
                  offeringName: this.props.testCase.offeringName,
                  termDescription: this.props.testCase.offers.filter(
                    (o) => o.code === this.state.fieldValues.term
                  )[0].description,
                  termCode: this.state.fieldValues.term,
                  pricingMethod: '',
                },
              ],
            },
          },
        ],
      };

      let mandatoryFieldsUpdated = this.props.fields.reduce((acc, f) => {
        if (f.mandatory === 'true') {
          if (!this.state.fieldValues[f.field]) {
            this.setState((state) => {
              return { errors: { ...state.errors, ...{ [f.field]: 'Error' } } };
            });
            return false;
          } else {
            this.setState((state) => {
              return { errors: { ...state.errors, ...{ [f.field]: '' } } };
            });
          }
        }
        return acc;
      }, true);

      if (
        mandatoryFieldsUpdated &&
        payload.testcases &&
        payload.testcases.length > 0 &&
        payload.testcases[0].orderid
      ) {
        this.props.submitOrder(payload, 'v2', 'bic');
        this.props.setDefaultFilter('newbuyingexperience');
      } else {
        // Reset loading state if validation fails
        this.setState({ isSubmitting: false });
      }
    } catch (error) {
      // Reset loading state on error
      console.error('Error submitting order:', error);
      this.setState({ isSubmitting: false });
    }
  }

  renderOptions(field) {
    if (field.field === 'term') {
      const options = this.props.options;
      return options.map((option) => (
        <option key={option.code} name={option.description} value={option.code}>
          {option.description}
        </option>
      ));
    } else {
      const options = field.options;
      return options.map((option) => {
        console.log(option);
        return (
          <option
            key={Object.keys(option)[0]}
            name={Object.values(option)[0]}
            value={Object.values(option)[0]}
          >
            {Object.values(option)[0]}
          </option>
        );
      });
    }
  }

  renderFields(fields) {
    return fields.map((field) => {
      const onChange = this.handleFormFieldChange(field.field);
      let input = null;

      if (field.type === 'select') {
        const options = this.renderOptions(field);
        input = (
          <select
            className="form-control"
            name={field.field}
            onChange={(e) => onChange(e.target.value)}
          >
            {options}
          </select>
        );
      } else if (field.type === 'password') {
        input = (
          <input
            className="form-control"
            type="password"
            name={field.field}
            value={this.state.fieldValues[field.field]}
            onChange={(e) => onChange(e.target.value)}
          />
        );
      } else {
        input = (
          <input
            className="form-control"
            type="text"
            name={field.field}
            value={this.state.fieldValues[field.field]}
            onChange={(e) => onChange(e.target.value)}
          />
        );
      }

      let optional;
      const tooltip = field.description ? (
        <Tooltip text={field.description} />
      ) : null;
      optional =
        field.mandatory === 'false' ? (
          <span className="optional-field">Optional</span>
        ) : (
          <span className="mandatory-field">*</span>
        );

      if (field.mandatory && field.mandatory.field) {
        let obj = field.mandatory.field;
        const isMandatory = Object.keys(obj).every(
          (k) => this.state[k] === obj[k]
        );
        optional = isMandatory === false ? <span>Optional</span> : null;
      }
      const hasError = this.state.errors[field.field] ? ' has-error' : '';

      return (
        <div key={field.field} className={`col-sm-6 form-group ${hasError}`}>
          <label htmlFor={field.field}>
            {field.name}
            {optional}
            {tooltip}
          </label>
          {input}
        </div>
      );
    });
  }

  renderForm() {
    const fields = this.renderFields(this.props.fields);

    return (
      <div className="modal-form">
        <div className="row">{fields}</div>
      </div>
    );
  }

  render() {
    const modalProps = {
      title: this.props.selectedProduct,
      onClose: this.props.onClose,
      onSubmit: this.handleSubmitFormClicked,
      submitEnabled: !!this.state.selectedOption && !this.state.isSubmitting,
      loading: this.props.isSending || this.state.isSubmitting,
    };
    const form = this.renderForm();

    return (
      <Modal {...modalProps}>
        <FlashMessage />
        {form}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  isSending: state.quarry.isSending,
  status: state.quarry.status,
});

const mapDispatchToProps = (dispatch) => ({
  setDefaultFilter: (source) => dispatch(setDefaultFilter(source)),
  submitOrder: (payload, version, channel) =>
    dispatch(submitOrder(payload, version, channel)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsModal);
